import {postAPI} from "../api";

function track(event: string, payload: any): void {
    const data = JSON.stringify(payload);

    postAPI("/api/events", {"event": event, "payload": data});
}

export default track;
